module.exports = __webpack_public_path__ + "img/blue-mountain.51351691.jpg";